package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.BadgeDemo
import example.shadcn_kotlin.ui.pages.components.demo.BadgeDestructive
import example.shadcn_kotlin.ui.pages.components.demo.BadgeOutline
import example.shadcn_kotlin.ui.pages.components.demo.BadgeSecondary

@Page
@Composable
fun BadgePage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/badge.md", mapOf("title" to listOf("Badge"), "description" to listOf("Displays a badge or a component that looks like a badge.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Badge

val BadgeDemo = FC<Props> {
    Badge {
        +"Badge"
    }
}"""){ 
 BadgeDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Badge
""", lang= "kotlin", highlight= "")
            CodeBlock("""Badge {
    variant="outline"
    +"Badge"
}
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("examples")
 }) {
                org.jetbrains.compose.web.dom.Text("Examples")
            }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("default")
 }) {
                org.jetbrains.compose.web.dom.Text("Default")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Badge

val BadgeDemo = FC<Props> {
    Badge {
        +"Badge"
    }
}"""){ 
 BadgeDemo {} 
 }
            org.jetbrains.compose.web.dom.Hr({ classes("my-4","md:my-8") })
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("secondary")
 }) {
                org.jetbrains.compose.web.dom.Text("Secondary")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Badge

val BadgeSecondary = FC<Props> {
    Badge {
        variant = "secondary"
        +"Secondary"
    }
}"""){ 
 BadgeSecondary {} 
 }
            org.jetbrains.compose.web.dom.Hr({ classes("my-4","md:my-8") })
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("outline")
 }) {
                org.jetbrains.compose.web.dom.Text("Outline")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Badge

val BadgeOutline = FC<Props> {
    Badge {
        variant="outline"
        +"Outline"
    }
}"""){ 
 BadgeOutline {} 
 }
            org.jetbrains.compose.web.dom.Hr({ classes("my-4","md:my-8") })
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("destructive")
 }) {
                org.jetbrains.compose.web.dom.Text("Destructive")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Badge

val BadgeDestructive = FC<Props> {
    Badge {
        variant = "destructive"
        +"Destructive"
    }
}"""){ 
 BadgeDestructive {} 
 }
        }
    }
}
